/**
 * схема для настроек таблицы брендов
 * @property {array} settingsItems - элементы настроек
 */
let schemeSettingsBrands = {
    columnSettings: {
        name: {
            type: 'input'
        },
        created_at: {
            type: 'text'
        },
    },
    labels: {
        name: 'Название бренда',
        created_at: 'Дата создания'
    }
}

export default schemeSettingsBrands;